import template from './unit-detail.html';
import controller from './unit-detail.controller';
import './unit-detail.scss';

let unitDetailComponent = {
  bindings: {},
  template,
  controller
};

export default unitDetailComponent;



// WEBPACK FOOTER //
// ./client/app/components/unit/unit-detail.component.js